/** Stored in `raw_payload.platform_cta` (manual ingest). */
export const ADS_PLATFORM_CTA_GENERIC = [
  { value: "", label: "Not specified" },
  { value: "none", label: "No CTA / text only" },
  { value: "unknown", label: "Unknown / other" },
] as const;

const GOOGLE_EXTRAS = [
  { value: "call_now", label: "Call now" },
  { value: "message_now", label: "Message now" },
  { value: "book", label: "Book" },
  { value: "directions", label: "Directions" },
  { value: "learn_more", label: "Learn more" },
  { value: "shop_now", label: "Shop now" },
] as const;

const FACEBOOK_EXTRAS = [
  { value: "call_now", label: "Call now" },
  { value: "learn_more", label: "Learn more" },
  { value: "shop_now", label: "Shop now" },
  { value: "sign_up", label: "Sign up" },
  { value: "contact_us", label: "Contact us" },
] as const;

export function adsPlatformCtaSelectOptions(platformKey: string): { value: string; label: string }[] {
  const p = platformKey.trim().toLowerCase();
  const base = ADS_PLATFORM_CTA_GENERIC.map((x) => ({ value: x.value, label: x.label }));
  if (p === "google") {
    return [...base.slice(0, 1), ...GOOGLE_EXTRAS, ...base.slice(1)];
  }
  if (p === "facebook") {
    return [...base.slice(0, 1), ...FACEBOOK_EXTRAS, ...base.slice(1)];
  }
  return [...base];
}
